import { useSWRConfig } from "swr";
import { useCachedSWR } from "../Utilities/useCachedSWR";
import { AUTH_SWR_KEYS } from "../Utilities/swrKeys";
import { apFetcher } from "../Utilities/axiosPrivateFetcher_SWR";
import { LogLevel } from "../../Shared/hooks/useLogging/Logging-types";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
/**
 * SWR hook for fetching My Meals menu data.
 * This hook returns cached data populated by AuthenticatedDataHydrator.
 * Data is hydrated at app initialization and revalidated on focus/reconnect.
 *
 * Optimized endpoint: /MyMeals/GetMyMealsMenuData
 * Returns only essential order properties for menu display (no cutoff calculations).
 */
export const useMyMealsMenuQuery = () => {
    const { datadogLog } = useLogging();
    const { mutate } = useSWRConfig();
    const { data, error, isLoading, isValidating } = useCachedSWR(AUTH_SWR_KEYS.MY_MEALS_MENU, {
        onSuccess: (data) => {
            if (!data.success) {
                const errorMessage = new Error("GetMyMealsMenuData returned success: false");
                datadogLog("GetMyMealsMenuData fetch error", LogLevel.ERROR, undefined, errorMessage);
            }
        },
        onError: (error) => {
            datadogLog("GetMyMealsMenuData error", LogLevel.ERROR, undefined, error);
        },
    });
    /**
     * Silently refresh the menu data in the background.
     * Fetches fresh data and updates the cache without blocking the UI.
     * Called when the menu is opened to ensure data is current.
     */
    const refresh = () => {
        mutate(AUTH_SWR_KEYS.MY_MEALS_MENU, apFetcher("/MyMeals/GetMyMealsMenuData")(), { revalidate: false });
    };
    return {
        data,
        error,
        isLoading,
        isValidating,
        refresh,
    };
};
